var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiwi-avatar",class:[_vm.hasAvatar ? 'kiwi-avatar--image' : ''],attrs:{"data-nick":_vm.message&&_vm.message.nick}},[_c('span',{style:(_vm.avatarStyle)},[_vm._v(_vm._s(_vm.hasAvatar ? '' : _vm.firstNickLetter))])])}
var staticRenderFns = []

export { render, staticRenderFns }